import { render, staticRenderFns } from "./eventEvaluation.vue?vue&type=template&id=ba136134&scoped=true&"
import script from "./eventEvaluation.vue?vue&type=script&lang=js&"
export * from "./eventEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./eventEvaluation.vue?vue&type=style&index=0&id=ba136134&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba136134",
  null
  
)

export default component.exports